import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

// Secondary-market orders & listings. Separate from the primary-market
// "My Orders" page (modules/orders) by product decision.
export const marketplaceOrdersRoutes: RouteRecordRaw[] = [
  {
    path: routes.MARKETPLACE_ORDERS,
    name: 'MARKETPLACE_ORDERS',
    component: () => import('./MarketplaceOrdersPage.vue'),
    meta: { requiresAuth: true, title: 'Orders & Listings', eyebrow: 'Marketplace' },
  },
  {
    path: routes.MARKETPLACE_ORDER_DETAIL,
    name: 'MARKETPLACE_ORDER_DETAIL',
    component: () => import('./MarketplaceOrderDetailPage.vue'),
    meta: { requiresAuth: true, title: 'Order Details', eyebrow: 'Marketplace' },
  },
]
